/**
 * Backend `invoice.payment_status` enum: pending | paid | refunded | partially_refunded.
 * Use only this for invoice rows — do not mix with order-level payment fields.
 */
export function getInvoicePaymentStatusNormalized(invoice: any): string {
  return String(invoice?.payment_status ?? "")
    .toLowerCase()
    .trim();
}

export function isInvoiceRefundCompleted(invoice: any): boolean {
  return getInvoicePaymentStatusNormalized(invoice) === "refunded";
}

function isInvoiceCod(invoice: any): boolean {
  return String(invoice?.payment_method ?? "").toLowerCase() === "cod";
}

/** Green "Paid" chip: non-COD and invoice payment status reflects funds captured/settled. */
export function isInvoicePaidChipPositive(invoice: any): boolean {
  if (isInvoiceCod(invoice)) return false;
  const s = getInvoicePaymentStatusNormalized(invoice);
  return s === "paid" || s === "refunded" || s === "partially_refunded";
}

/** Refunded / Refund Pending chip on cancelled flow: non-COD and invoice has a payment status. */
export function shouldShowCancelledInvoiceRefundChip(invoice: any): boolean {
  if (isInvoiceCod(invoice)) return false;
  return getInvoicePaymentStatusNormalized(invoice).length > 0;
}

export const getDateRange = async (range: string) => {
    let fromDate = "";
    let toDate = "";
    if(range === "today") {
        fromDate = new Date().toISOString().split("T")[0];
        toDate = new Date().toISOString().split("T")[0];
    }
    else if(range === "last 7 days") {
        fromDate = new Date(new Date().setDate(new Date().getDate() - 7)).toISOString().split("T")[0];
        toDate = new Date().toISOString().split("T")[0];
    }
    else if(range === "last 30 days") {
        fromDate = new Date(new Date().setDate(new Date().getDate() - 30)).toISOString().split("T")[0];
        toDate = new Date().toISOString().split("T")[0];
    }
    return { fromDate, toDate };
}